import request from './index'
const domain = process.env.NODE_ENV != 'development' ? process.env.VUE_APP_XINGJIAN_API ?? '' : ''
// const domain = process.env.VUE_APP_XINGJIAN_API ?? ''
// const domain = 'https://igaoxin-apix-test.chinacici.com'

// 请求接口封装
export const axiosPost = (url, params, config) => request.post(domain + url, params, config)
export const axiosPut = (url, query, config) => request.put(domain + url, query, config)

export const axiosGet = (url, query, config) => request.get(domain + url, { params: query, ...config })
export const axiosDelete = (url, params, config) => request.delete(domain + url, params, config)
export const axiosGetNoEncrypt = (url, query, config) => request.get(domain + url, { params: query, ...{ noEncrypt: true, config } })
export const axiosPostNoEncrypt = (url, params, config) => request.post(domain + url, params, { ...config, noEncrypt: true })
